import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UsersComponent } from './users.component';
import { UsersListComponent } from './users-list/users-list.component';
import { UsersDetailsComponent } from './users-details/users-details.component';
import { RolesPopupComponent } from './users-details/roles-popup/roles-popup.component';
import { AddEditCompanyComponent } from './users-details/add-edit-company/add-edit-company.component';
import { PermitsComponent } from './permits/permits.component';
import { UserManagementService } from './services/user-management.service';
import { AngularMaterialModule } from 'app/angular-material.module';
import { SharedModule } from '../common/shared.module';
import { RouterModule } from '@angular/router';
import { FuseHighlightModule, FuseWidgetModule } from '@fuse/components';
import { FuseShortcutsModule } from '../fuse/components/shortcuts/shortcuts.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { RolesComponent } from './roles/roles.component';
import { ControlDeAccesosComponent } from './users-details/control-de-accesos/control-de-accesos.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReactiveFormsModule } from '@angular/forms';
import { PermitGroupsComponent } from './permits/tabs/permit-groups/permit-groups.component';

@NgModule({
    declarations: [
        UsersComponent,
        UsersListComponent,
        UsersDetailsComponent,
        RolesPopupComponent,
        AddEditCompanyComponent,
        PermitsComponent,
        RolesComponent,
        ControlDeAccesosComponent,
        PermitGroupsComponent
    ],
    imports: [
        CommonModule,
        FuseSharedModule,
        FuseHighlightModule,
        FuseWidgetModule,
        RouterModule,
        AngularMaterialModule,
        SharedModule,
        FuseShortcutsModule,
        NgSelectModule,
        MatExpansionModule,
        ReactiveFormsModule
    ],
    exports: [
        ReactiveFormsModule
    ],
    providers: [
        UserManagementService
    ]
})
export class UserManagementModule { }
